<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item label="关键字：">
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询关键字"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <div class="btn-box" style="float: right;">
            <el-form-item>
              <el-button type="primary" size="small" @click="handleAdd">
                新增
                <i class="el-icon-plus el-icon--right" />
              </el-button>
            </el-form-item>
            <el-form-item>
              <upload-excel-component
                style="display:inline;"
                :on-success="handleImportSuccess"
                :before-upload="handleBeforeUpload"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                style="margin-left: 8px"
                size="small"
                type="primary"
                @click="handleExport()"
              >
                导出
                <i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      :expand-row-keys="expands"
      :row-key="getRowKeys"
      :tree-props="{children: 'children' }"
      @sort-change="handleResort"
      @expand-change="handleShowDtl"
    >
      >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" />

      <!-- 版本 -->
      <el-table-column
        prop="banBen"
        width="150"
        sortable="custom"
        align="center"
        label="版本"
      />

      <!-- 类别 -->
      <el-table-column
        prop="leiBieDictId"
        width="120"
        sortable="custom"
        align="center"
      >
        <template slot="header">
          <span class="red-star">* </span>
          <span>类别</span>
        </template>
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{
              scope.row.leibieDictIdItemName
            }}</span>
            <el-select
              v-if="scope.row.isEdit"
              v-model="scope.row.leibieDictId"
              clearable
              filterable
              placeholder="请选择类别"
              size="small"
              style="display: inline"
            >
              <el-option
                v-for="item in getComboxData('D82')"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </template>
      </el-table-column>

      <!-- 主要用途 -->
      <el-table-column
        prop="zhuYaoYongTu"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot="header">
          <span class="red-star">* </span>
          <span>主要用途</span>
        </template>
        <template slot-scope="scope">
          <div>
            <el-button
              v-if="!scope.row.isEdit"
              type="text"
              size="small"
              @click.native.prevent="handleToDtl(scope.row.id)"
            >
              {{ scope.row.zhuYaoYongTu }}
            </el-button>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.zhuYaoYongTu"
              prop="zhuYaoYongTu"
              size="small"
              placeholder="请输入主要用途"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 更新内容 -->
      <el-table-column
        prop="gengXinNeiRong"
        label="更新内容"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.gengXinNeiRong }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.gengXinNeiRong"
              prop="gengXinNeiRong"
              size="small"
              placeholder="请输入更新内容"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 已用于 -->
      <el-table-column
        prop="usedTo"
        label="已用于"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">
              {{ scope.row.usedTo }}
            </span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.usedTo"
              prop="usedTo"
              size="small"
              placeholder="已用于"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 使用时间 -->
      <el-table-column
        prop="usedDate"
        label="使用时间"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">
              {{ scope.row.usedDateShow }}
            </span>
            <el-date-picker
              v-if="scope.row.isEdit"
              v-model="scope.row.usedDate"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="请选择使用时间"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 简介内容 -->
      <el-table-column
        prop="jianJieNeiRong"
        label="简介内容"
        :show-overflow-tooltip="true"
        sortable="custom"
        align="center"
        min-width="200px"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{
              scope.row.jianJieNeiRongShow
            }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.jianJieNeiRong"
              prop="jianJieNeiRong"
              size="small"
              placeholder="请输入简介内容"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="250" align="left">
        <template slot-scope="scope">
          <span>
            <el-button
              v-if="!scope.row.isEdit"
              type="text"
              size="mini"
              plain
              @click.stop="handleEdit(scope.row, scope.$index)"
            >
              修改
            </el-button>
            <el-button
              v-if="scope.row.isEdit"
              type="text"
              size="small"
              @click.stop="handleSave(scope.row)"
            >
              保存
            </el-button>
            <el-button
              v-if="scope.row.isEdit"
              type="text"
              size="small"
              @click.stop="handleCancel(scope.row, scope.$index)"
            >
              取消
            </el-button>
            <el-button
              v-if="!scope.row.isEdit"
              type="text"
              size="mini"
              @click.stop="handleDel(scope.row)"
            >
              删除
            </el-button>
            <el-button
              v-if="!scope.row.isEdit"
              type="text"
              size="mini"
              @click.stop="handleAddChild(scope.row)"
            >
              创建子版本
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next, total, sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <ShowUpload
      v-model="uploadFormShow"
      :upload-data="uploadData"
      @save-success="handleSearch"
    />
    <gr05child
      v-model="gr05ChildShow"
      :type-code="childTypeCode"
      :entity-id="dtlEntityId"
      @save-success="handleSearch"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import ShowUpload from './ShowUpload'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import KxjCom from '@/utils/kxjcom'
import gr05child from './gr05child'
export default {
  name: 'UploadExcel',
  components: {
    ShowUpload,
    UploadExcelComponent,
    gr05child
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      moduleCode: 'gr05',
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      tableDataDtl: [],
      allComboxData: [],
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: ''
      },
      uploadData: [],
      uploadFormShow: false,
      gr05ChildShow: false,
      dtlEntityId: null,
      childTypeCode: null,
      expands: [] // 只展开一行放入当前行id,
    }
  },

  // 初期化数据
  created() {
    this.handleSearch()
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D82').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {},
  // 画面激活
  activated() {
    this.handleSearch()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },

    getRowKeys(row) {
      return row.id
    },
    /** 展开 */
    handleShowDtl(row, expandedRows) {
      const that = this
      that.tableDataDtl = []
      var parm = {
        keyword: row.banBen
      }
      const path = '/api/services/app/GR05/GetChildList'
      pathReq
        .getForm(path, parm)
        .then(res => {
          that.tableDataDtl = res.data.result.items
        })
        .then(_ => {
          // 只展开一行
          if (expandedRows.length) {
            // 说明展开了
            that.expands = []
            if (row) {
              that.expands.push(row.id) // 只展开当前行id
            }
          } else {
            // 说明收起了
            that.expands = []
          }
        })

      // if (expandedRows.length > 0) {
      //   var parm = {
      //     keyword: row.banBen
      //   }
      //   const path = '/api/services/app/GR05/GetChildList'
      //   pathReq.getForm(path, parm).then(res => {
      //     that.tableDataDtl = res.data.result.items
      //   })
      // } else {
      //   that.tableDataDtl = []
      // }

      // if (p.length > 0) {
      // } else {
      //   this.tableDataDtl = []
      // }
    },
    // 新增
    handleAdd() {
      const dataNew = {
        id: null,
        isEdit: true,
        canBeEdit: true,
        isParent: true,
        ziBanBenHao: 0
      }
      this.tableData.unshift(dataNew)
    },
    // 查询
    handleSearch() {
      const that = this
      that.expands = []
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/GR05/GetPagedListGR05s'
      pathReq.getList(path, that.searchForm).then(res => {
        loading.close()
        that.totalCount = res.data.result.totalCount
        that.tableData = res.data.result.items
      })
    },
    // 编辑
    handleEdit(row) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].isEdit) {
          if (this.tableData[i].id) {
            this.tableData[i].isEdit = false
          } else {
            this.tableData.splice(i, 1)
            i--
          }
        }
        row.isEdit = true
      }
    },
    // 取消
    handleCancel(row, index) {
      row.isEdit = false
      if (!row.id) {
        this.tableData.splice(index, 1)
      }
    },
    // 删除
    handleDel(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$loading(KxjCom.loadOptions)
          const path = '/api/services/app/GR05/DeleteGR05'
          pathReq.dataDelete(path, row.id).then(res => {
            this.$message.success('删除成功!')
            that.handleSearch()
          })
        })
        .catch(() => {})
    },
    // 新建或修改信息就是保存的时候
    handleSave(row) {
      if (!row.leibieDictId) {
        this.$message.error('请选择类别')
        return false
      }
      if (!row.zhuYaoYongTu) {
        this.$message.error('请输入主要用途')
        return false
      }

      const that = this
      var obj = { entityData: row }
      this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/GR05/CreateOrUpdateGR05'
      pathReq.postForm(path, obj).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.handleSearch()
          }
        }
      })
    },
    // 只能查看
    handleShowDetail(row, index) {
      console.log(row)
      console.log(index)
      alert('转到查看画面')
    },
    /** 增加子版本 */
    handleAddChild(row) {
      this.gr05ChildShow = true
      this.dtlEntityId = row.id
      this.childTypeCode = 1
    },
    /** 增加子版本(子版本中) */
    handleAddChild2(row) {
      this.gr05ChildShow = true
      this.dtlEntityId = row.id
      this.childTypeCode = 1
    },
    /** 修改子版本 */
    handleEditChild(row, index) {
      this.gr05ChildShow = true
      this.dtlEntityId = row.id
      this.childTypeCode = 2
    },
    /**
     * 显示课程信息
     */
    handleToDtl(id) {
      this.$router.push({
        name: 'gr05dtl',
        params: { id: id, moduleCode: this.moduleCode }
      })
    },
    // 导入
    handleBeforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (isLt5M) {
        return true
      }
      this.$message.warning('数据超过5M')
      return false
    },
    handleImportSuccess({ results, header }) {
      const filterVal = [
        'leibieDictId',
        'banBen',
        'gengXinNeiRong',
        'zhuYaoYongTu',
        'jianJieNeiRong'
      ]
      const data = KxjCom.formatJson(header, results)
      var b = []
      for (var i = 0; i < data.length; i++) {
        b.push(KxjCom.formatObj(filterVal, data[i]))
      }
      this.uploadData = b
      for (const row of this.uploadData) {
        row.leibieDictId = KxjCom.getComboxKeyByText(
          row.leibieDictId,
          this.getComboxData('D82')
        )
      }

      this.uploadFormShow = true
    },

    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['类别', '版本', '更新内容', '主要用途', '简介内容']
        const filterVal = [
          'leibieDictIdItemName',
          'zhuYaoYongTu',
          'banBen',
          'jianJieNeiRong',
          'gengXinNeiRong'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '个人简介', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
/* ffc059 */
.red-star {
  color: red;
}
</style>
